export { default, type GradientSectionProps } from './GradientSection';
